(function () {
  'use strict';

  var root = document.querySelector('[data-spirit-offer]');
  if (!root || root.__spiritOfferReady) return;
  root.__spiritOfferReady = true;

  // Don't show on checkout / cart / account flows.
  var path = window.location.pathname || '';
  if (/\/(checkout|cart|account|orders)(\/|$)/.test(path) || /thank[_-]?you/.test(path)) return;

  var apiBase = root.getAttribute('data-api-base') || '';
  if (!apiBase) return;
  var delay = parseInt(root.getAttribute('data-delay'), 10);
  if (isNaN(delay)) delay = 7000;

  // Add ?smoffer=preview to any URL to force the pop-up open right away and
  // bypass the once-per-session cap — handy for previewing offers on the shop.
  var forcePreview = /[?&#]smoffer=preview/i.test(window.location.href);
  if (forcePreview) delay = 600;

  var card = root.querySelector('[data-spirit-offer-card]');
  var backdropEl = root.querySelector('[data-spirit-offer-backdrop]');
  var closeBtn = root.querySelector('[data-spirit-offer-close]');
  var link = root.querySelector('[data-spirit-offer-cta]');
  var mediaEl = root.querySelector('[data-spirit-offer-media]');
  var imageEl = root.querySelector('[data-spirit-offer-image]');
  var badgeEl = root.querySelector('[data-spirit-offer-badge]');
  var headlineEl = root.querySelector('[data-spirit-offer-headline]');
  var subEl = root.querySelector('[data-spirit-offer-sub]');
  var ctaLabelEl = root.querySelector('[data-spirit-offer-ctalabel]');
  var timerEl = root.querySelector('[data-spirit-offer-timer]');
  var timerClockEl = root.querySelector('[data-spirit-offer-timer-clock]');
  var timerLabelEl = root.querySelector('[data-spirit-offer-timer-label]');
  var timerInterval = null;

  // Share the visitor identity with Luma so analytics stitch across systems.
  var visitorId = window.localStorage.getItem('spiritAiVisitorId') || '';
  if (!visitorId) {
    visitorId = 'v_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
    try { window.localStorage.setItem('spiritAiVisitorId', visitorId); } catch (e) {}
  }
  var sessionId = window.sessionStorage.getItem('smSessionId') || '';
  if (!sessionId) {
    sessionId = 's_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
    try { window.sessionStorage.setItem('smSessionId', sessionId); } catch (e) {}
  }

  var offer = null;
  var openedAt = 0;
  var closed = false;

  function sendEvent(eventName, extra) {
    var body = Object.assign({
      offerId: offer && offer.offerId ? offer.offerId : undefined,
      visitorId: visitorId,
      sessionId: sessionId,
      eventName: eventName
    }, extra || {});
    var json = JSON.stringify(body);
    // Use fetch + keepalive (same as Luma, which records reliably). sendBeacon
    // with an application/json blob returns true but is silently dropped by some
    // browsers (notably mobile Safari) on cross-origin preflighted requests, so
    // the events never arrive. keepalive lets the request survive the click
    // navigation too.
    try {
      fetch(apiBase + '/api/offer-events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: json,
        keepalive: true,
        mode: 'cors'
      }).catch(function () {});
    } catch (e) {}
  }

  function dwell() { return openedAt ? Math.max(0, Date.now() - openedAt) : undefined; }

  // 60-minute urgency countdown for code-based (e.g. free-shipping) offers.
  // The deadline is stored in localStorage so it keeps counting across page
  // navigations within the visitor's session rather than resetting each view.
  var COUNTDOWN_MS = 60 * 60 * 1000;
  function startCountdown() {
    if (!timerEl || !timerClockEl || !offer || !offer.discountCode) return;
    var deadline = 0;
    try { deadline = parseInt(window.localStorage.getItem('smOfferDeadline') || '0', 10); } catch (e) {}
    var now = Date.now();
    if (!deadline || deadline <= now) {
      deadline = now + COUNTDOWN_MS;
      try { window.localStorage.setItem('smOfferDeadline', String(deadline)); } catch (e) {}
    }
    timerEl.hidden = false;
    function tick() {
      var rem = deadline - Date.now();
      if (rem <= 0) {
        timerClockEl.textContent = '00:00';
        if (timerLabelEl) timerLabelEl.textContent = 'Last chance for free shipping';
        root.classList.add('is-expired');
        if (timerInterval) { window.clearInterval(timerInterval); timerInterval = null; }
        return;
      }
      var totalSec = Math.floor(rem / 1000);
      var m = Math.floor(totalSec / 60);
      var s = totalSec % 60;
      timerClockEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    tick();
    timerInterval = window.setInterval(tick, 1000);
  }

  function show() {
    // Never stack on top of Luma's open chat.
    var luma = document.querySelector('[data-spirit-ai-chat]');
    if (luma && luma.classList.contains('is-open')) return;

    root.hidden = false;
    window.__smOfferOpen = true;
    document.documentElement.classList.add('sm-offer-open');
    // next frame so the slide-up transition runs
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { root.classList.add('is-open'); });
    });
    openedAt = Date.now();
    sendEvent('offer_impression', {});
    startCountdown();
  }

  function hide() {
    if (closed) return;
    closed = true;
    if (timerInterval) { window.clearInterval(timerInterval); timerInterval = null; }
    root.classList.remove('is-open');
    window.__smOfferOpen = false;
    document.documentElement.classList.remove('sm-offer-open');
    window.setTimeout(function () { root.hidden = true; }, 350);
  }

  function dismiss() {
    var d = dwell();
    sendEvent('offer_dismiss', d === undefined ? {} : { dwellMs: d });
    hide();
  }

  closeBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); dismiss(); });
  if (backdropEl) backdropEl.addEventListener('click', function (e) { e.preventDefault(); dismiss(); });

  link.addEventListener('click', function () {
    var offerId = (offer && offer.offerId) || '';
    var stamp = offerId + '|' + visitorId;
    // Primary attribution: write a cart attribute. Shopify carries cart
    // attributes into the order's note_attributes, which our backend reads via
    // the Orders API to credit this offer with the purchase — no discount code,
    // no thank-you script, works on every checkout. (Same-origin on storefront.)
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { sm_offer: stamp } }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
    // Backup attribution cookie (in case a cart isn't created before checkout).
    try {
      document.cookie = 'sm_offer=' + encodeURIComponent(stamp) +
        '; path=/; max-age=259200; SameSite=Lax';
    } catch (e) {}
    var d = dwell();
    sendEvent('offer_click', d === undefined ? {} : { dwellMs: d });
    // For code-based (free-shipping) offers, arm the site-wide header
    // countdown: flag the claim and lock in the 60-minute deadline (reusing
    // the pop-up's deadline if one is already running, otherwise starting a
    // fresh 60 minutes from this click).
    if (offer && offer.discountCode) {
      try {
        var dl = parseInt(window.localStorage.getItem('smOfferDeadline') || '0', 10);
        if (!dl || dl <= Date.now()) {
          dl = Date.now() + 60 * 60 * 1000;
          window.localStorage.setItem('smOfferDeadline', String(dl));
        }
        window.localStorage.setItem('smFreeShipClaimed', '1');
      } catch (e) {}
    }
    // Let the browser follow the link (href set when the offer loaded).
    window.__smOfferOpen = false;
    document.documentElement.classList.remove('sm-offer-open');
  });

  function render() {
    link.setAttribute('href', offer.ctaUrl || '#');
    headlineEl.textContent = offer.headline || '';
    if (offer.subtext) { subEl.textContent = offer.subtext; subEl.hidden = false; }
    else { subEl.hidden = true; }
    if (offer.badge) { badgeEl.textContent = offer.badge; badgeEl.hidden = false; }
    else { badgeEl.hidden = true; }
    if (offer.imageUrl) {
      imageEl.src = offer.imageUrl;
      imageEl.hidden = false;
      if (mediaEl) mediaEl.hidden = false;
    } else {
      imageEl.hidden = true;
      if (mediaEl) mediaEl.hidden = true; /* no broken empty hero band */
    }
    ctaLabelEl.textContent = offer.ctaLabel || 'Shop now';
  }

  // Show at most once per visitor per 24h (unless previewing). Stored in
  // localStorage so it holds across page navigations, tabs and sessions.
  var FREQ_MS = 24 * 60 * 60 * 1000;
  function recentlyShown() {
    try {
      var last = parseInt(window.localStorage.getItem('smOfferLastShown') || '0', 10);
      return last && (Date.now() - last) < FREQ_MS;
    } catch (e) { return false; }
  }

  function load() {
    if (!forcePreview && recentlyShown()) return;
    fetch(apiBase + '/api/offer?visitorId=' + encodeURIComponent(visitorId))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.offerId) return;
        offer = data;
        if (!forcePreview) { try { window.localStorage.setItem('smOfferLastShown', String(Date.now())); } catch (e) {} }
        render();
        show();
      })
      .catch(function () {});
  }

  window.setTimeout(load, delay);
})();
